webpackJsonp([24],{

/***/ 1001:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(3);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(7);

// EXTERNAL MODULE: ./src/components/inputs/index.js + 75 modules
var inputs = __webpack_require__(170);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/ForgotPassword.vue





/* harmony default export */ var ForgotPassword = ({
  components: {
    TextInput: inputs["t" /* TextInput */]
  },
  data: function data() {
    return {
      success: false,
      form: {
        email: null
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    platformName: 'application/platformName',
    loading: 'skiliko/password/isLoading'
  })),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    sendEmail: 'skiliko/password/sendEmail'
  }), {
    submit: function submit() {
      var _this = this;

      var data = extends_default()({}, this.form);
      data.platformName = data.platformName || this.platformName;
      this.sendEmail(data).then(function (_) {
        return _this.success = true;
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b679741","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ForgotPassword.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"reset"},[_c('v-card-title',[_vm._v("\n      "+_vm._s(_vm.$t('pages.forgotpassword.title'))+"\n    ")]),_vm._v(" "),_c('v-card-text',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit()}}},[(!_vm.platformName)?_c('text-input',{attrs:{"config":{ required: true, label: _vm.$t('pages.forgotpassword.labels.platformName'), suffix: 'liveconsult.io' }},model:{value:(_vm.form.platformName),callback:function ($$v) {_vm.$set(_vm.form, "platformName", $$v)},expression:"form.platformName"}}):_vm._e(),_vm._v(" "),_c('text-input',{key:"email",attrs:{"config":{ type: 'email', required: true, label: _vm.$t('pages.forgotpassword.labels.email') }},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}}),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","primary":"","light":"","block":"","ripple":"","loading":_vm.loading}},[_vm._v("\n          "+_vm._s(_vm.$t('pages.forgotpassword.reset'))+"\n        ")])],1)])],1),_vm._v(" "),_c('v-snackbar',{attrs:{"success":"","multi-line":"","timeout":2000},model:{value:(_vm.success),callback:function ($$v) {_vm.success=$$v},expression:"success"}},[_vm._v("\n    "+_vm._s(_vm.$t('pages.forgotpassword.success'))+"\n  ")]),_vm._v(" "),_c('v-btn',{attrs:{"block":"","flat":"","light":"","router":"","href":{ name: 'Login' }}},[_vm._v(_vm._s(_vm.$t('pages.forgotpassword.login')))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var pages_ForgotPassword = (esExports);
// CONCATENATED MODULE: ./src/pages/ForgotPassword.vue
function injectStyle (ssrContext) {
  __webpack_require__(965)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b679741"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  ForgotPassword,
  pages_ForgotPassword,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_pages_ForgotPassword = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 965:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(966);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(747)("9eecc4b4", content, true);

/***/ }),

/***/ 966:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(746)(true);
// imports


// module
exports.push([module.i, ".reset[data-v-2b679741]{width:350px;max-width:100%}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/pages/ForgotPassword.vue"],"names":[],"mappings":"AACA,wBACE,YAAa,AACb,cAAgB,CACjB","file":"ForgotPassword.vue","sourcesContent":["\n.reset[data-v-2b679741] {\n  width: 350px;\n  max-width: 100%;\n}"],"sourceRoot":""}]);

// exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/24.29d9c77c20cd1ffdde9d.js